<template>
  <div class="form-element">
    <label class="form-element__title" v-if="title">{{ title }}</label>
    <div class="form-element__radio -little" :class="classObject" >
      <!-- class="form-element__radio__item -little" -->
      <div
         :style="displayGrid"
        class="form-element__radio__item -little"
        :class="{ '-picked': item.name == picked, '-border': isBorder }"
        v-for="item in options"
        :key="`option-${item.name}`"
      >
        <input
          type="radio"
          name="option"
          :id="item.name"
          :value="item.name"
          v-model="picked"
        />
        <label class="-little" :for="item.name" v-html="item.name"></label>
        <div v-if="item.name=='Kuveyt Türk banka hesabından talimat ile ödeme' && item.name==picked"
        class="form-element__message" style="padding-left:5%;color:red"
         >*Kuveyt Türk Banka şubenizden “Otomatik Ödeme Talimatı” vermeniz gerekmektedir.</div>
      </div>

    </div>
    <div class="form-element__message" v-if="message">{{ message }}</div>
    <div
      class="form-element__message"
      :class="{ '-error': isError }"
      v-if="message2"
      style="color:red"
    >
      {{ message2 }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
    message2: {
      type: String,
      default: null,
    },
    isFull: {
      type: Boolean,
      default: false,
    },
    isHalf: {
      type: Boolean,
      default: false,
    },
    isBorder: {
      type: Boolean,
      default: false,
    },
    isError:{
      type: Boolean,
      default: false,
    },

    displayGrid:{
      type:String,
      default:null
    }
  },
  data() {
    return {
      picked: this.value,
    };
  },
  watch: {
    value: function (val) {
      this.picked = val;
    },
    picked: function (val) {
      this.$emit("input", val);
    },
  },
  computed: {
    classObject: function () {
      let list = {
        "-row": this.isFull,
        "-half": this.isHalf,
        "-SelectError": this.isError,
      };

      return list;
    },
  },

};
</script>